import type { EditRowDef } from '../../../types'
import { isFormValid } from '../../../helpers/isFormValid'

export function isEditFormValid(
  rows: EditRowDef[],
  values: Record<string, unknown>
): boolean {
  const editableFields = rows
    .filter((row) => row.mode === 'editable')
    .map((row) => row.field)
  return isFormValid(editableFields, values)
}
